import type { NextRouter } from "next/router"

export type QueryParams = NextRouter["query"]

export interface WebUrl {
  pathname: string
  query?: QueryParams
}

export function webUrlToString(url: WebUrl): string {
  const query = url.query

  if (!query || Object.keys(query).length === 0) {
    return url.pathname
  }

  const urlSearchParams = new URLSearchParams()

  Object.entries(query).forEach(([key, value]) => {
    if (value === undefined) return
    if (Array.isArray(value)) {
      value.forEach((v) => urlSearchParams.append(key, v))
    } else {
      urlSearchParams.set(key, value)
    }
  })

  return (
    url.pathname +
    (urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : "")
  )
}
